/**-----------------------------------------------------------------------------
 * Last order
 * Provide a button to load customer's last confirmed order.
 */
import jQuery from 'jquery';
import _ from 'lodash';

const { Customer } = Mobi2Go;
const { Order } = Mobi2Go;

Mobi2Go.UI.View({
    name: 'customer_last_order',
    model: Customer,
    el: '[data-view="customer-last-order"]',
    template: jQuery('[data-template="customer-last-order"]').html(),

    // Hook to allow adjusting of the last order query
    // Useful if the headoffice has changed their menu and the change
    // is affecting customer's previous orders
    query_override: {},
    order_filter() {
        return true;
    },

    initialise() {
        const that = this;
        Customer.bind({
            logIn: this.fetchCustomersLastOrderForMenu,
            logOut: this.reset,
        });

        Order.bind({
            updateMenu() {
                that.render(); // Will hide button if necessary
                that.fetchCustomersLastOrderForMenu();
            },
            updateId(id) {
                if (!id) {
                    that.render(); // Will hide button if necessary
                    that.fetchCustomersLastOrderForMenu(true);
                }
            },
            updateProductsQuantity(quantity) {
                quantity ? that.hide() : that.show();
            },
        });
    },
    fetchCustomersLastOrderForMenu(force_update) {
        const menu = Order.getMenu();

        if (!Customer.isLoggedIn() || Customer.isGuest() || !menu) {
            return;
        }

        if (!force_update && this.last_orders_by_menu[menu.id]) {
            this.render();
            return;
        }

        const that = this;
        const query = _.extend(
            {
                menu: menu.id,
                progress_phase: 'confirmed',
                limit: 1,
                sort_by: 'desc',
            },
            this.query_override
        );

        this.last_orders_by_menu[menu.id] = true; // Will prevent concurrent xhr
        Customer.getOrders(query, function(orders) {
            orders = _.filter(orders, that.order_filter);
            that.last_orders_by_menu[menu.id] = orders ? orders[0] : null;
            that.render();
        });
    },
    render() {
        const html = this.template({ order: this.getLastOrderState() });
        this.$el.html(html);
    },
    last_orders_by_menu: {},
    getLastOrderState() {
        const menu = Order.getMenu();
        return menu ? this.last_orders_by_menu[menu.id] || null : null;
    },
    loadLastOrder() {
        const lastOrderState = this.getLastOrderState() || {};
        Order.apply(lastOrderState).save(function() {
            Mobi2Go.UI.trigger('lastOrderLoaded', lastOrderState);
            Order.log("customer's last order loaded");
        });
    },
    hide() {
        this.$el.addClass('m2g-hidden');
    },
    show() {
        this.$el.removeClass('m2g-hidden');
    },
    reset() {
        this.last_orders_by_menu = {};
        this.render();
    },
    DOM_listeners: {
        'click [data-load-last-order]': 'loadLastOrder',
    },
});
